// @ts-nocheck
/* Port of EmptyState.js (31L). BYTE-IDENTICAL. */
import React from 'react';

const EmptyState = ({
  variant = 'no-releases',
  canManage,
  onCreate,
  onReset,
}: any) => {
  const isNoResults = variant === 'no-results';
  return (
    <div className="rc-empty rc-fade-up">
      <div className="rc-empty__art" aria-hidden="true">
        {isNoResults ? '🔍' : '🚀'}
      </div>
      <h3>{isNoResults ? 'No matching releases' : 'The story starts here'}</h3>
      <p>
        {isNoResults
          ? "Try a different search term or clear your filters to see everything we've shipped."
          : 'No releases have been published yet. When you ship something worth celebrating, it will appear here as a beautiful timeline.'}
      </p>
      {isNoResults ? (
        <button type="button" className="rc-btn" onClick={onReset}>
          Clear filters
        </button>
      ) : (
        canManage && (
          <button
            type="button"
            className="rc-btn rc-btn--primary"
            onClick={onCreate}
          >
            + Create your first release
          </button>
        )
      )}
    </div>
  );
};

export default EmptyState;
